/**
 * shop-self-fulfilment D2 — an item named by its title and its option. A
 * product the studio adds has one option labelled with its own name, so the
 * label is left out where it only repeats the title. Browser-safe.
 */

/** The option's label as shown beside its product's title; null when it only repeats the title. */
export function shownOptionLabel(productTitle: string, optionLabel: string): string | null {
  return optionLabel.trim() === productTitle.trim() ? null : optionLabel;
}
